module.exports = __webpack_public_path__ + "petits_points_blanc.svg?db047930017f67faa9486d26cf2fd917";


//////////////////
// WEBPACK FOOTER
// ./src/img/qui_sommes_nous/petits_points_blanc.svg
// module id = 133
// module chunks = 0